import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'
import store from './store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './page/login.vue'), // 登录页
      meta: {
        auth: false,
        keepAlive: false,
        deepth: 0
      }
    },
    {
      path: '/main',
      name: 'main',
      component: () =>
        import(/* webpackChunkName: "main" */ './page/index.vue'), // 主页
      meta: {
        auth: true,
        keepAlive: false,
        deepth: 0.5
      },
      children: [
        {
          path: '/raw-materials',
          name: 'RawMaterials',
          component: () =>
            import(/* webpackChunkName: "raw-materials" */ './page/product/materials'), // 原材料信息列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'production',
            activePath: '/raw-materials',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/loose-tea-batches',
          name: 'LooseTeaList',
          component: () =>
            import(/* webpackChunkName: "loose-tea-batches" */ './page/product/loose-tea'), // 原材料信息列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'production',
            activePath: '/loose-tea-batches',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/product',
          name: 'ProductList',
          component: () =>
            import(/* webpackChunkName: "product" */ './page/product/list'), // 商品备案列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'production',
            activePath: '/product',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/product-detail',
          name: 'product-detail',
          component: () =>
            import(/* webpackChunkName: "product-detail" */ './page/product/detail'), // 新增编辑商品备案
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/product',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/product-update',
          name: 'product-update',
          component: () =>
            import(/* webpackChunkName: "product-update" */ './page/product/edit'), // 新增编辑商品备案
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/product',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/product-infos',
          name: 'ProductInfos',
          component: () =>
            import(/* webpackChunkName: "product-infos" */ './page/product-infos/infos'), // 商品信息（维护证书/种植/生产信息）列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'production',
            activePath: '/product-infos',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/certificate-detail',
          name: 'certificate-detail',
          component: () =>
            import(/* webpackChunkName: "certificate-detail" */ './page/certificate/detail'), // 证书列表
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/product-infos',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/plat-env-detail',
          name: 'plat-env-detail',
          component: () =>
            import(/* webpackChunkName: "plat-env-detail" */ './page/plat-env/detail'), // 种植环境详情
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/product-infos',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/work-env-detail',
          name: 'work-env-detail',
          component: () =>
            import(/* webpackChunkName: "work-env-detail" */ './page/work-env/detail'), // 生产环境详情
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/product-infos',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/batch',
          name: 'BatchList',
          component: () =>
            import(/* webpackChunkName: "batch" */ './page/batch/list'), // 批次备案列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'production',
            activePath: '/batch',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/batch-create',
          name: 'batch-create',
          component: () =>
            import(/* webpackChunkName: "batch-create" */ './page/batch/create'), // 新增编辑批次备案
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/batch',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/batch-detail',
          name: 'batch-detail',
          component: () =>
            import(/* webpackChunkName: "batch-detail" */ './page/batch/detail'), // 新增编辑批次备案
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/batch',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/batch-update',
          name: 'batch-update',
          component: () =>
            import(/* webpackChunkName: "batch-update" */ './page/batch/update'), // 新增编辑批次备案
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/batch',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/inspect',
          name: 'InspectList',
          component: () =>
            import(/* webpackChunkName: "inspect" */ './page/inspect/list'), // 质量管理列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'production',
            activePath: '/inspect',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/inspect-create',
          name: 'inspect-create',
          component: () =>
            import(/* webpackChunkName: "inspect-create" */ './page/inspect/edit'), // 新增质量管理
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/inspect',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/inspect-detail',
          name: 'inspect-detail',
          component: () =>
            import(/* webpackChunkName: "inspect-detail" */ './page/inspect/detail'), // 质量管理详情
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/inspect',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/inspect-update',
          name: 'inspect-update',
          component: () =>
            import(/* webpackChunkName: "inspect-update" */ './page/inspect/edit'), // 新增编辑质量管理
          meta: {
            auth: true,
            activeTopPath: 'production',
            activePath: '/inspect',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/inventory',
          name: 'InventoryList',
          component: () =>
            import(/* webpackChunkName: "inventory" */ './page/inventory/list'), // 仓储管理
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'warehouse',
            activePath: '/inventory',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/inventory-check',
          name: 'InventoryCheckList',
          component: () =>
            import(/* webpackChunkName: "inventory-check" */ './page/inventory-check/list'), // 盘库管理
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'warehouse',
            activePath: '/inventory-check',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/transfer-stock',
          name: 'AllocateList',
          component: () =>
            import(/* webpackChunkName: "transfer-stock" */ './page/allocate-list/list'), // 调拨单列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'orders',
            activePath: '/transfer-stock',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/transfer-stock-detail',
          name: 'transfer-stock-detail',
          component: () =>
            import(/* webpackChunkName: "transfer-stock-detail" */ './page/allocate-list/detail'), // 调拨单详情
          meta: {
            // noReturn: true,
            auth: true,
            activeTopPath: 'orders',
            activePath: '/transfer-stock',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/outstock',
          name: 'OutstockList',
          component: () =>
            import(/* webpackChunkName: "outstock" */ './page/outstock/list'), // 出库单列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'warehouse',
            activePath: '/outstock',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/delivery-order',
          name: 'DeliveryOrderList',
          component: () =>
            import(/* webpackChunkName: "delivery-order" */ './page/delivery-order/list'), // 发货单列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'warehouse',
            activePath: '/delivery-order',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/orders',
          name: 'OrderList',
          component: () =>
            import(/* webpackChunkName: "orders" */ './page/orders/list'), // 订单列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'orders',
            activePath: '/orders',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/query-orders',
          name: 'QueryOrdersList',
          component: () =>
            import(/* webpackChunkName: "query-orders" */ './page/orders/query-orders'), // 订单列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'orders',
            activePath: '/query-orders',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/orders-create',
          name: 'orders-create',
          component: () =>
            import(/* webpackChunkName: "orders-create" */ './page/orders/create'), // 新增订单
          meta: {
            auth: true,
            activeTopPath: 'orders',
            activePath: '/orders',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/orders-detail',
          name: 'orders-detail',
          component: () =>
            import(/* webpackChunkName: "outstock-detail" */ './page/orders/detail'), // 订单详情
          meta: {
            auth: true,
            activeTopPath: 'orders',
            activePath: '/orders',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/rework-order',
          name: 'ReworkList',
          component: () =>
            import(/* webpackChunkName: "rework-order" */ './page/rework/list'), // 返工单列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'production',
            activePath: '/rework-order',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/tally-order',
          name: 'TallyOrderList',
          component: () =>
            import(/* webpackChunkName: "tally-order" */ './page/tally-order/list'), // 理货单列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'warehouse',
            activePath: '/tally-order',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/tally-order-detail',
          name: 'tally-order-detail',
          component: () =>
            import(/* webpackChunkName: "tally-order-detail" */ './page/tally-order/tally-order-detail'), // 理货单明细
          meta: {
            // noReturn: true,
            auth: true,
            activeTopPath: 'warehouse',
            activePath: '/tally-order',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/aftersales-order',
          name: 'AfterSalesList',
          component: () =>
            import(/* webpackChunkName: "aftersales-order" */ './page/after-sales/list'), // 售后单列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'orders',
            activePath: '/aftersales-order',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/aftersales-order-create',
          name: 'aftersales-order-create',
          component: () =>
            import(/* webpackChunkName: "aftersales-order-edit" */ './page/after-sales/create'), // 新建补单
          meta: {
            auth: true,
            activeTopPath: 'orders',
            activePath: '/aftersales-order',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/goodsreturn',
          name: 'GoodsreturnList',
          component: () =>
            import(/* webpackChunkName: "goodsreturn" */ './page/goodsreturn/list'), // 退货单
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'warehouse',
            activePath: '/goodsreturn',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/goodsreturn-x',
          name: 'GoodsreturnList',
          component: () =>
            import(/* webpackChunkName: "goodsreturn-x" */ './page/goodsreturn/list'), // 退货单
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'orders',
            activePath: '/goodsreturn-x',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-portal',
          name: 'WxappPortalList',
          component: () =>
            import(/* webpackChunkName: "wxapp-portal" */ './page/wxapp-portal/index'), // 首页设置
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-portal',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-portal-edit',
          name: 'wxapp-portal-edit',
          component: () =>
            import(/* webpackChunkName: "wxapp-portal-edit" */ './page/wxapp-portal/edit'), // 首页设置编辑
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-portal',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-message',
          name: 'WxappMessageIndex',
          component: () =>
            import(/* webpackChunkName: "wxapp-message" */ './page/wxapp-message/index'), // 门户-内容设置-列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-message',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-message-detail',
          name: 'wxapp-message-detail',
          component: () =>
            import(/* webpackChunkName: "wxapp-message-detail" */ './page/wxapp-message/detail'), // 门户-内容设置-详情
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-message',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-message-edit',
          name: 'wxapp-message-edit',
          component: () =>
            import(/* webpackChunkName: "wxapp-message-edit" */ './page/wxapp-message/edit'), // 门户-内容设置-编辑
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-message',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-sku',
          name: 'WxappSkuList',
          component: () =>
            import(/* webpackChunkName: "wxapp-sku" */ './page/wxapp-sku/index'), // 商品-列表
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-sku',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-sku-detail',
          name: 'wxapp-sku-detail',
          component: () =>
            import(/* webpackChunkName: "wxapp-sku-detail" */ './page/wxapp-sku/detail'), // 商品-详情
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-sku',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-sku-edit',
          name: 'wxapp-sku-edit',
          component: () =>
            import(/* webpackChunkName: "wxapp-sku-edit" */ './page/wxapp-sku/edit'), // 商品-编辑
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-sku',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-order',
          name: 'WxappOrderIndex',
          component: () =>
            import(/* webpackChunkName: "wxapp-order" */ './page/wxapp-order/index'), // 订单-订单查询
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-order',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-order-detail',
          name: 'wxapp-order-detail',
          component: () =>
            import(/* webpackChunkName: "wxapp-order-detail" */ './page/wxapp-order/detail'), // 订单-订单查询-详情
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-order',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-aftersale',
          name: 'WxappAftersaleList',
          component: () =>
            import(/* webpackChunkName: "wxapp-aftersale" */ './page/wxapp-aftersale/index'), // 订单-退换货管理
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-aftersale',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-agent',
          name: 'WxappAgentList',
          component: () =>
            import(/* webpackChunkName: "wxapp-agent" */ './page/wxapp-agent/index'), // 合伙人
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-agent',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-agent-detail',
          name: 'wxapp-agent-detail',
          component: () =>
            import(/* webpackChunkName: "wxapp-agent-detail" */ './page/wxapp-agent/detail'), // 合伙人业绩明细
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-agent',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-withdraw',
          name: 'WxappAgentWithdrawals',
          component: () =>
            import(/* webpackChunkName: "wxapp-withdraw" */ './page/wxapp-agent/withdrawals'), // 提现申请
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-withdraw',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-user',
          name: 'WxappUserList',
          component: () =>
            import(/* webpackChunkName: "wxapp-user" */ './page/wxapp-user/info/index'), // 会员-会员信息
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-user',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-user-detail',
          name: 'wxapp-user',
          component: () =>
            import(/* webpackChunkName: "wxapp-user-detail" */ './page/wxapp-user/info/detail'), // 会员-会员信息
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-user',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-user-setting',
          name: 'wxapp-user-setting',
          component: () =>
            import(/* webpackChunkName: "wxapp-user-setting" */ './page/wxapp-user/settings/index'), // 会员-会员设置
          meta: {
            // noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-user',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-user-detail',
          name: 'wxapp-user-detail',
          component: () =>
            import(/* webpackChunkName: "wxapp-user-detail" */ './page/wxapp-user/info/detail'), // 会员-会员信息
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-user',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-set',
          name: 'WxappSettings',
          component: () =>
            import(/* webpackChunkName: "wxapp-set" */ './page/wxapp-set/index'), // 通用设置
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-set',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-marketing',
          name: 'WxappMarketingList',
          component: () =>
            import(/* webpackChunkName: "wxapp-marketing" */ './page/wxapp-marketing/index'), // 活动-liebiao
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-marketing',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/wxapp-marketing-discount',
          name: 'wxapp-marketing-discount',
          component: () =>
            import(/* webpackChunkName: "wxapp-marketing-discount" */ './page/wxapp-marketing/discount/index'), // 限时特惠
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-marketing',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-marketing-lottery',
          name: 'wxapp-marketing-lottery',
          component: () =>
            import(/* webpackChunkName: "wxapp-marketing-lottery" */ './page/wxapp-marketing/lottery/index'), // 单品抽奖
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-marketing',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-marketing-coupon',
          name: 'wxapp-marketing-coupon',
          component: () =>
            import(/* webpackChunkName: "wxapp-marketing-coupon" */ './page/wxapp-marketing/coupon/index'), // 优惠券
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-marketing',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-marketing-draw',
          name: 'wxapp-marketing-draw',
          component: () =>
            import(/* webpackChunkName: "wxapp-marketing-draw" */ './page/wxapp-marketing/draw/index'), // 报名抽奖
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-marketing',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-marketing-receive',
          name: 'wxapp-marketing-receive',
          component: () =>
            import(/* webpackChunkName: "wxapp-marketing-receive" */ './page/wxapp-marketing/receive/index'), // 线下领奖
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-marketing',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-point',
          name: 'wxapp-point',
          component: () =>
            import(/* webpackChunkName: "wxapp-point" */ './page/wxapp-point/task/index'), // 积分任务
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-set',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/wxapp-point-pay',
          name: 'wxapp-point-pay',
          component: () =>
            import(/* webpackChunkName: "wxapp-point-pay" */ './page/wxapp-point/pay/index'), // 积分-现金
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-set',
            keepAlive: false,
            deepth: 3
          }
        },
        {
          path: '/wxapp-point-scan',
          name: 'wxapp-point-scan',
          component: () =>
            import(/* webpackChunkName: "wxapp-point-scan" */ './page/wxapp-point/scan/index'), // 积分-扫码
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/wxapp-set',
            keepAlive: false,
            deepth: 3
          }
        },
        {
          path: '/tagscan-scene',
          name: 'WxappH5List',
          component: () =>
            import(/* webpackChunkName: "wxapp-h5" */ './page/wxapp-h5/index'), // 扫码场景
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/tagscan-scene',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/stat-stock-new',
          name: 'stat-stock-new',
          component: () =>
            import(/* webpackChunkName: "stat-stock-new" */ './page/stat/inventory'), // 库存统计
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'stat',
            activePath: '/stat-stock-new',
            keepAlive: false,
            deepth: 1
          }
        },
        {
          path: '/stat-safetystock',
          name: 'stat-safetystock',
          component: () =>
            import(/* webpackChunkName: "stat-safetystock" */ './page/stat/safe'), // 安全库存统计
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'stat',
            activePath: '/stat-safetystock',
            keepAlive: false,
            deepth: 1
          }
        },
        {
          path: '/stat-order',
          name: 'stat-order',
          component: () =>
            import(/* webpackChunkName: "stat-order" */ './page/stat/order'), // 订单统计
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'stat',
            activePath: '/stat-order',
            keepAlive: false,
            deepth: 1
          }
        },
        {
          path: '/stat-product-trading',
          name: 'stat-product-trading',
          component: () =>
            import(/* webpackChunkName: "stat-product-trading" */ './page/stat/product-new'), // 商品统计
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'stat',
            activePath: '/stat-product-trading',
            keepAlive: false,
            deepth: 1
          }
        },
        {
          path: '/stat-cust-trading',
          name: 'stat-cust-trading',
          component: () =>
            import(/* webpackChunkName: "stat-cust-trading" */ './page/stat/customer.vue'), // 客户统计
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'stat',
            activePath: '/stat-cust-trading',
            keepAlive: false,
            deepth: 1
          }
        },
        {
          path: '/wxapp-h5-edit',
          name: 'wxapp-h5-edit',
          component: () =>
            import(/* webpackChunkName: "wxapp-h5-edit" */ './page/wxapp-h5/edit'), // 扫码场景设置
          meta: {
            auth: true,
            activeTopPath: 'weapp',
            activePath: '/tagscan-scene',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/settings',
          name: 'NewSettings',
          component: () =>
            import(/* webpackChunkName: "settings" */ './page/settings/list'), // hscode
          meta: {
            noReturn: true,
            auth: true,
            activeTopPath: 'settings',
            activePath: '/settings',
            keepAlive: true,
            deepth: 1
          }
        },
        {
          path: '/logs',
          name: 'logs-list',
          component: () =>
            import(/* webpackChunkName: "logs-list" */ './page/logs/list'), // 操作日志
          meta: {
            auth: true,
            activeTopPath: 'settings',
            activePath: '/settings',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/notify-fail-logs',
          name: 'notify-fail-logs',
          component: () =>
            import(/* webpackChunkName: "notify-fail-logs" */ './page/logs/notify-fail-logs'), // 推送失败日志
          meta: {
            auth: true,
            activeTopPath: 'settings',
            activePath: '/settings',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/customer-list',
          name: 'customer-list',
          component: () =>
            import(/* webpackChunkName: "customer-list" */ './page/customer/list'), // 客户列表
          meta: {
            auth: true,
            activeTopPath: 'settings',
            activePath: '/settings',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/customer-delivery-list',
          name: 'customer-delivery-list',
          component: () =>
            import(/* webpackChunkName: "customer-delivery-list" */ './page/delivery/list'), // 客户收件地址列表
          meta: {
            auth: true,
            activeTopPath: 'settings',
            activePath: '/settings',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/customer-delivery-detail',
          name: 'customer-delivery-detail',
          component: () =>
            import(/* webpackChunkName: "customer-delivery-detail" */ './page/delivery/detail'), // 客户收件地址列表
          meta: {
            auth: true,
            activeTopPath: 'settings',
            activePath: '/settings',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/customer-delivery-edit',
          name: 'customer-delivery-edit',
          component: () =>
            import(/* webpackChunkName: "customer-delivery-edit" */ './page/delivery/edit'), // 客户收件地址列表
          meta: {
            auth: true,
            activeTopPath: 'settings',
            activePath: '/settings',
            keepAlive: false,
            deepth: 2
          }
        },
        {
          path: '/print-test',
          name: 'print-test',
          component: () =>
            import(/* webpackChunkName: "print-test" */ './page/outstock/print-test'), // 客户收件地址列表
          meta: {
            auth: true,
            // activeTopPath: 'settings',
            // activePath: '/settings',
            keepAlive: false,
            deepth: 2
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const userInfo = store.state.account.userInfo
  // console.log(to, from)
  if (to.meta.auth && !userInfo.token) {
    Message.error('请先登录')
    setTimeout(() => {
      if (process.env.VUE_APP_BUILD_MODE === 'FHZ_WEB') {
        window.parent.postMessage({ type: 'user_logout' }, '*')
      } else {
        next({
          path: '/login'
        })
      }
    }, 1500)
  } else {
    next()
  }
})

router.afterEach(() => {})

export default router
